query ParticipantVerificationDetails($orderId: ID!) {
  order(id: $orderId) {
    participants {
      nodes {
        id
        participantVerifications {
          id
          gid
          status
          idPhotoUrl
          selfieUrl
          latitude
          longitude
          submittedAt
          createdAt
        }
      }
    }
  }
}
